import React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import Farmer360logo from '../../assets/Farmer360logo.png';

const AdminNavbar = () => {
	return (
		<AppBar position="fixed" sx={{ backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }} elevation={0}>
			<Toolbar>
				<img src={Farmer360logo} alt="Farmer360" style={{ height: 52, objectFit: 'contain' }} />
			</Toolbar>
		</AppBar>
	);
};

export default AdminNavbar;
